export const IDLE_SESSION_TIMEOUT = 30;
